import {
  DEFAULT_DESCRIPTION,
  DEFAULT_DESKTOP_BG,
  DEFAULT_MOBLE_BG,
  DEFAULT_TITLE,
  PRICE_DATA,
  TABLE_FULL_DATA,
} from '@/const/service/maintenance-list/lcv';
import { BUTTON_LCV_FIND_SERVICE_CENTER_BORDER } from '@/contents/lcv/link';

export const META_TAG_DATA = {
  title:
    'รายการอะไหล่บำรุงรักษาตามระยะ และราคาประเมิน - อีซูซุประเทศไทย Isuzu Thailand Official',
  description:
    'ตรวจสอบรายการอะไหล่บำรุงรักษาตามระยะ ราคาประเมินพร้อมส่วนลด และโปรโมชันก่อนนำรถเข้าเช็กระยะได้ที่นี่',
};
export const MAINTENANCE_LIST = {
  title: DEFAULT_TITLE,
  description: DEFAULT_DESCRIPTION,
  defaultPlaceholder: {
    imageMobile: DEFAULT_MOBLE_BG,
    imageDesktop: DEFAULT_DESKTOP_BG,
    placeholder: 'กรุณาเลือกรุ่นรถ',
  },
  table: {
    data: {
      priceData: PRICE_DATA,
    },
    full: TABLE_FULL_DATA,
    brief: {
      dealerSearchButton: {
        button: BUTTON_LCV_FIND_SERVICE_CENTER_BORDER,
        test: {
          dataTest: 'maintenance-list-table-brief_findDealer',
        },
        tracking: {
          dataTrack: 'maintenance-list-table-brief-findDealer',
        },
      },
    },
  },
};
